import axios from 'axios';

export default class {

    static get = async id => {
        let result = {
            data: null,
            error: null
        };

        await axios.get(`${process.env.REACT_APP_API_URL}/users/${id}`)
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response.data;
            });

        return result;
    }

    static signup = async obj => {
        let result = {
            data: null,
            error: null
        };

        await axios.post(`${process.env.REACT_APP_API_URL}/users/signup`, obj)
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response.data;
            });

        return result;
    }

    static updatePersonalInformation = async (token, obj) => {
        let result = {
            data: null,
            error: null
        };

        await axios.post(`${process.env.REACT_APP_API_URL}/users/update-personal-info`, obj,
            { headers: { 'app_auth_token': token } })
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response.data;
            });

        return result;
    }

    static updateDeliveryAddress = async (token, obj) => {
        let result = {
            data: null,
            error: null
        };

        await axios.post(`${process.env.REACT_APP_API_URL}/users/update-delivery-address`, obj,
            { headers: { 'app_auth_token': token } })
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response.data;
            });

        return result;
    }
    
    static activateAccount = async id => {
        let result = {
            data: null,
            error: null
        };

        const data = { token: id };

        await axios.post(`${process.env.REACT_APP_API_URL}/users/activate`, data)
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response.data;
            });

        return result;
    }

    static login = async (email, password) => {
        let result = {
            data: null,
            error: null
        };

        const data = {
            email: email,
            password: password
        };

        await axios.post(`${process.env.REACT_APP_API_URL}/users/login`, data)
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response.data;
            });

        return result;
    }

    static forgotPassword = async email => {
        let result = {
            data: null,
            error: null
        };

        const data = {
            email: email
        };

        await axios.post(`${process.env.REACT_APP_API_URL}/users/forgot-password`, data)
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response.data;
            });

        return result;
    }

    static resetPassword = async (token, password) => {
        let result = {
            data: null,
            error: null
        };

        const data = {
            token: token,
            newPassword: password
        };

        await axios.post(`${process.env.REACT_APP_API_URL}/users/reset-password`, data)
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response.data;
            });

        return result;
    }

    static updatePassword = async (token, currentPassword, newPassword) => {
        let result = {
            data: null,
            error: null
        };

        const data = {
            currentPassword,
            newPassword
        };

        await axios.post(`${process.env.REACT_APP_API_URL}/users/update-password`, data,
            { headers: { 'app_auth_token': token } })
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response.data;
            });

        return result;
    }

    static updateName = async (token, newName) => {
        let result = {
            data: null,
            error: null
        };

        const data = { name: newName };

        await axios.post(`${process.env.REACT_APP_API_URL}/users/update-name`, data,
            { headers: { 'app_auth_token': token } })
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response.data;
            });

        return result;
    }

    static updatePicture = async (token, obj) => {
        let result = {
            data: null,
            error: null
        };

        const fd = new FormData();
        for (const [key, value] of Object.entries(obj)) {
            fd.append(key, value);
        }

        await axios.post(`${process.env.REACT_APP_API_URL}/users/update-picture`, fd,
            { headers: { 'app_auth_token': token } })
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response.data;
            });

        return result;
    }
}